import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import { FaCalendarCheck, FaVideo } from 'react-icons/fa';
import ProductShowcase from '../../components/plataforma/ProductShowcase';

function DashboardHome() {
    const [userName, setUserName] = useState('');
    const [nextAppointment, setNextAppointment] = useState(null);
    const [coursesCount, setCoursesCount] = useState(0);

    useEffect(() => {
        const name = localStorage.getItem('userName');
        if (name) setUserName(name);

        // Fetch appointments
        api.get('/appointments')
            .then(response => {
                // Filter for future appointments and sort
                const future = response.data
                    .filter(a => new Date(a.date) > new Date())
                    .sort((a, b) => new Date(a.date) - new Date(b.date));

                if (future.length > 0) {
                    setNextAppointment(future[0]);
                }
            })
            .catch(err => console.log('Erro ao buscar agendamentos', err));

        // Fetch courses
        api.get('/my-courses')
            .then(response => {
                setCoursesCount(response.data.length);
            })
            .catch(err => console.log('Erro ao buscar cursos', err));
    }, []);

    return (
        <div className="dashboard-home">
            <header className="dashboard-header">
                <h1>Olá, {userName}!</h1>
                <p>Bem-vindo de volta à sua área exclusiva.</p>
            </header>

            <div className="card-grid">
                {/* Card Agendamento */}
                <div className="dashboard-card">
                    <div className="card-title">
                        <FaCalendarCheck style={{ color: 'var(--primary-color)' }} />
                        Próximo Agendamento
                    </div>
                    <div className="card-value" style={{ fontSize: nextAppointment ? '1.2rem' : '1.5rem' }}>
                        {nextAppointment ? (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                                <span>{new Date(nextAppointment.date).toLocaleDateString('pt-BR')} às {new Date(nextAppointment.date).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}</span>
                                <span style={{ fontSize: '1rem', color: 'var(--text-light)', fontWeight: 'normal' }}>{nextAppointment.service}</span>
                            </div>
                        ) : (
                            'Nenhum agendado'
                        )}
                    </div>
                    <Link to="/plataforma/agendar" className="btn-primary" style={{ marginTop: '1.5rem', width: '100%', textAlign: 'center' }}>
                        Novo Agendamento
                    </Link>
                </div>

                {/* Card Cursos */}
                <div className="dashboard-card">
                    <div className="card-title">
                        <FaVideo style={{ color: 'var(--primary-color)' }} />
                        Meus Cursos
                    </div>
                    <div className="card-value">
                        {coursesCount} <span style={{ fontSize: '1rem', fontWeight: 'normal', color: 'var(--text-light)' }}>disponíveis</span>
                    </div>
                    <Link to="/plataforma/cursos" className="btn-outline" style={{ marginTop: '1.5rem', width: '100%', textAlign: 'center', display: 'block' }}>
                        Continuar Assistindo
                    </Link>
                </div>
            </div>

            {/* Vitrine de Produtos */}
            <div style={{ marginTop: '3rem' }}>
                <ProductShowcase />
            </div>
        </div>
    );
}

export default DashboardHome;
